import { ErrorCode } from './enums/ErrorCode';
function getClientErrorMessage(code) {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const date = now.getDate().toString().padStart(2, '0');
    const hour = now.getHours().toString().padStart(2, '0');
    const min = now.getMinutes().toString().padStart(2, '0');
    const second = now.getSeconds().toString().padStart(2, '0');
    switch (code) {
        case ErrorCode.SYSTEM_ERROR:
            return `发生错误，请稍候重试\n(F-${year}${month}${date}${hour}${min}${second})`;
        case ErrorCode.CLIENT_NETWORK_ERROR:
            return '似乎已断开与互连网的连结，请检查网路设置后重试';
        case ErrorCode.CLIENT_TIMEOUT:
            return '操作失败，请稍后重试';
        default:
            // return null
            // FAYTODO: 測試錯誤訊息
            return '这是一个非预期的错误';
    }
}
export default class GDKError extends Error {
    name;
    code;
    lang;
    response;
    original;
    constructor(original, lang, code, response = null) {
        super('GDKError');
        this.name = 'GDKError';
        this.code = code;
        this.lang = lang;
        this.response = response;
        this.original = original;
        try {
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            this.message = response?.message || getClientErrorMessage(code) || original?.message || '';
        }
        catch (error) {
            console.error(error);
        }
    }
}
//# sourceMappingURL=GDKError.js.map